"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Elements = require("../../Elements");

var _Patterns = require("../../Patterns");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ExternalLink = function ExternalLink(_a) {
  var children = _a.children,
      modalOptions = _a.modalOptions,
      href = _a.href,
      onClick = _a.onClick,
      props = (0, _tslib.__rest)(_a, ["children", "modalOptions", "href", "onClick"]);

  var _b = _react.default.useState(false),
      modalOpen = _b[0],
      setModalOpen = _b[1];

  var handleExternal = function handleExternal(e) {
    e.preventDefault();
    setModalOpen(true);
    onClick && onClick(e);
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Elements.Anchor, (0, _tslib.__assign)({
    as: "button",
    "data-testid": "Anchor",
    fontSize: "1em",
    onClick: handleExternal
  }, props), children), _react.default.createElement(_Patterns.LeavingDialog, (0, _tslib.__assign)({
    href: href,
    isOpen: modalOpen,
    onClose: function onClose() {
      return setModalOpen(false);
    }
  }, modalOptions)));
};

var _default = ExternalLink;
exports.default = _default;